import { Pipe, PipeTransform } from '@angular/core';
import { PaymentTypes } from '@sondermind/features/public-facing/session-request';

@Pipe({
  name: 'insurancePlanLabel'
})
export class InsurancePlanLabelPipe implements PipeTransform {
  transform(paymentPref: PaymentTypes | null | undefined): string {
    const prefix = 'Your';
    const planType = this.getPlanType(paymentPref);
    return `${prefix} ${planType} plan`.trim();
  }

  private getPlanType(paymentPref: PaymentTypes | null | undefined): string {
    switch (paymentPref) {
      case PaymentTypes.EAP:
        return 'EAP insurance';
      case PaymentTypes.MEDICARE:
        return 'Medicare';
      case PaymentTypes.MEDICAID:
        return 'Medicaid';
      default:
        return 'insurance';
    }
  }
}
